const PaymentChannels = {
  E_COMMERCE: 'e-commerce',
  MOTO: 'moto',
  POS: 'pos',
  RECURRING: 'recurring',
};

module.exports = PaymentChannels;
